const {
  isPlainObject
} = require('lodash');
const {
  evaluateSource
} = require('../../lib/evaluateSource');
const {
  processAssignments
} = require('../../lib/irtc/assignmentGroups');

/**
  * @function evalute - evaluate itiAssignmentCountsBehavior
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const checklists = await evaluateSource(source.checklists, content, parentContentPath, transientContext, nativeFunctions);
  if (checklists === undefined || !isPlainObject(checklists)) {
    return undefined;
  }
  const result = {
    open: 0,
    complete: 0,
    unassigned: 0
  };
  processAssignments(checklists, (identifier, plusOpen, plusComplete) => {
    if (identifier === undefined) {
      result.unassigned += 1;
    } else {
      result.open += plusOpen;
      result.complete += plusComplete;
    }
  });
  return result;
};
module.exports = {
  evaluate
};